module.exports = __webpack_public_path__ + "img/customer-logo.a3ca13f8.svg";